import React from "react";

import { X } from "lucide-react";

import Button from "../Button";
import "./style.scss";

interface SidebarModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string | React.ReactNode;
  className?: string;
  headerActions?: React.ReactNode;
  footer?: React.ReactNode;
}

const SidebarModal: React.FC<SidebarModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  className,
  headerActions,
  footer,
}) => {
  if (!isOpen) return null;
  return (
    <div className={`${className || ""}`}>
      <div className="sidebar-modal__overlay" onClick={onClose} />
      <div className="sidebar-modal__container">
        <div className="sidebar-modal__header flex items-center justify-between gap-2">
          <h1 className="sidebar-modal__title flex-1 min-w-0">{title}</h1>
          <div className="flex items-center gap-1 shrink-0">
            {headerActions}
            <Button
              variant="clear"
              onClick={onClose}
              className="share-modal__close-btn"
            >
              <X style={{ height: 13, width: 13 }} />
            </Button>
          </div>
        </div>
        <div className="sidebar-modal__content">{children}</div>
        {footer ? (
          <div className="sidebar-modal__footer border-t border-gray-100">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SidebarModal;
